export default {
  name: 'CoworkersMixin',
  data() {
    return {
        coworkerValues: [ "geen", "1 - 4", "5 - 9", "10 - 19", "20 - 50", "meer dan 50" ]
    }
  },
  methods: {
      printCoWorkers : function(coworkerIndex) {
          return this.coworkerValues[coworkerIndex]
      }
  }
}
